var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('material-card',{attrs:{"heading":_vm.heading,"icon-small":"","icon":"mdi-help","title":_vm.heading,"color":"primary"}},[_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }